import { DEFAULT_TOP_ACTIONS, TopActions } from '../../../transactions/constants/Actions'

/**
 * The backend sends action names as strings on `instance_slot_data`; `TransactionDetails` takes the
 * numeric enums. Keep the lookup keyed by the enum's own member names so adding a member to
 * `Actions.ts` is picked up here without a second edit.
 *
 * Unknown names are dropped rather than throwing: a beat configured against a newer ditto config
 * than the bundle should render with the actions it *does* understand, not blow up the drawer.
 */
const TOP_ACTION_BY_NAME: Record<string, TopActions> = {
  Category: TopActions.Category,
  Date: TopActions.Date,
  Memo: TopActions.Memo,
  Tags: TopActions.Tags,
}

const resolve = <T>(names: string[] | undefined, lookup: Record<string, T>, fallback: T[]): T[] => {
  // `undefined` means "not configured" -> defaults. An explicit empty array means "no actions",
  // which is a legitimate per-beat choice (a read-only details view) and must not fall back.
  if (!names) return fallback

  return names.map((name) => lookup[name]).filter((action): action is T => action !== undefined)
}

export const resolveTopActions = (names?: string[]): TopActions[] =>
  resolve(names, TOP_ACTION_BY_NAME, DEFAULT_TOP_ACTIONS)
